export var getIsMenuItemShown = function (_a) {
    var additionalProductConfig = _a.additionalProductConfig, productConfigInFullList = _a.productConfigInFullList, productConfigInInjectedItems = _a.productConfigInInjectedItems, responseMenuItem = _a.responseMenuItem;
    if (additionalProductConfig.hidden || responseMenuItem.hidden) {
        return false;
    }
    var hasInlineConfig = Boolean(productConfigInFullList.config);
    var hasStaticUrl = Boolean(productConfigInFullList.staticURL);
    var wasLoaded = productConfigInInjectedItems.loaded;
    return (Boolean(responseMenuItem.nextLevelItems) ||
        hasInlineConfig ||
        hasStaticUrl ||
        wasLoaded ||
        Boolean(additionalProductConfig.customClickType) ||
        Boolean(additionalProductConfig.eventName) ||
        Boolean(responseMenuItem.eventName));
};
